<template>
  <div class="container scroll-list-wrap">
    <!-- 
    <ul class="nav">
      <li>
        <router-link to='/Index'>企业介绍</router-link>
      </li>
      <li class="current" style="position: relative">
        <router-link to='/Product'>产品列表</router-link>
      </li>
      <li style="position: relative">
        <router-link to='/Video'>实时监控</router-link>
      </li>
    </ul>-->

    <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp"
    >
      <ul class="foods-wrapper">
        <li v-for="food in items" class="food-item border-1px">
          <div class="icon">
            <img width="57" height="57" :src="food.mainImg" />
          </div>
          <div class="food-content">
            <h2 class="name">{{food.pname}}</h2>
            <p class="description">{{food.pdesc}}</p>
          </div>
        </li>
      </ul>
      <template v-if="customPullDown" slot="pulldown" slot-scope="props">
        <div
          v-if="props.pullDownRefresh"
          class="cube-pulldown-wrapper"
          :style="props.pullDownStyle"
        >
          <div
            v-show="props.beforePullDown"
            class="before-trigger"
            :style="{paddingTop: props.bubbleY + 'px'}"
          >
            <span :class="{rotate: props.bubbleY > pullDownRefreshThreshold - 40}">↓</span>
          </div>
          <div class="after-trigger" v-show="!props.beforePullDown">
            <div v-show="props.isPullingDown" class="loading">
              <cube-loading></cube-loading>
            </div>
            <div v-show="!props.isPullingDown" class="text">
              <span class="refresh-text">{{pullDownRefreshTxt}}</span>
            </div>
          </div>
        </div>
      </template>
    </cube-scroll>
  </div>
</template>

<script>
// import { createCode } from "@/api/api";
import goodsData from "../assets/example/goods-list.json";
import { broducts } from "@/api/bapi";
import { broduct_type } from "@/api/bapi";
import { organization_list } from "@/api/bapi";
import { brand_list } from "@/api/bapi";
import { addUser5 } from "@/api/bapi";
import { dict_list } from "@/api/bapi";
import { productmodel } from "@/api/bapi";
import { deleteProduct } from "@/api/bapi";

export default {
  name: "Product",
  data() {
    return {
      menu_show: false,
      menu_show1: false,
      selectedLabelDefault: "首页",
      tabs: [
        {
          label: "首页",
          icon: "cubeic-home"
        },
        {
          label: "我的",
          icon: "cubeic-person"
        }
      ],
      items: [],
      pullDownRefresh: true,
      pullDownRefreshThreshold: 60,
      pullDownRefreshStop: 40,
      pullDownRefreshTxt: "加载成功",
      pullUpLoad: true,
      pullUpLoadThreshold: 0,
      pullUpLoadMoreTxt: "加载更多",
      pullUpLoadNoMoreTxt: "没有更多数据了",
      customPullDown: true,
      // props:{
      //   bubbleY: '20'
      // }
      currentPage: 1,
      total: 0,
      title: "",
      page: {
        current: 1,
        size: 10
      }
    };
  },
  watch: {
    $route(to, from) {
      if (/\/Product/gi.test(to.path)) {
        this.items = [];
        this.page.current = 1;
        this.getList();
      }
    }
  },
  created() {
    this.getList();
  },
  computed: {
    options() {
      return {
        pullDownRefresh: true, //this.pullDownRefreshObj,
        pullUpLoad: true, //this.pullUpLoadObj,
        scrollbar: true
      };
    }
  },
  methods: {
    changeHandler(label) {
      if (label == "我的") {
        this.$router.push({ path: "Center" });
      } else {
        this.$router.push({ path: "Index" });
      }
    },
    getList() {
      //获取列表
      broducts({
        current: this.page.current,
        size: this.page.size,
        PName: this.title
      })
        .then(res => {
          if (res.status == 200) {
            res.data.data.records.forEach(o => {
              this.items.push(o);
            });
            this.currentPage = res.data.data.current;
            this.total = res.data.data.total;
          }
        })
        .catch(function(reason) {
          this.$Message.error("您暂无权限");
        });
    },
    onPullingDown() {
      console.log(123123);
      // 模拟更新数据
      // 更新数据
      setTimeout(() => {
        this.items = [];
        this.page.current = 1;
        this.getList();
      }, 1000);
    },
    onPullingUp() {
      setTimeout(() => {
        if (this.total > this.items.length) {
          this.page.current++;
          this.getList();
        } else {
          // 如果没有新数据
          this.$refs.scroll.forceUpdate();
        }
      }, 1000);
    }
  }
};
</script>

<style scoped>
.introduce {
  text-align: left;
  font-size: 0.8rem;
  color: #999999;
  padding: 0rem 1rem;
  background-color: white;
  margin: 0 0.5rem;
  padding: 0.8rem;
  border-radius: 6px;
  z-index: 1;
  position: relative;
  top: -20px;
}
.introduce p {
  margin-bottom: 0.5rem;
}
.store {
  background-color: white;
  padding: 0.8rem;
}
.img_content {
  display: flex;
  margin: 10px 0;
  justify-content: space-around;
}
.store p {
  width: 30%;
}
.store p img {
  width: 100%;
}
.list {
  padding-bottom: 60px;
}
.left_img {
  width: 30%;
}
.left_img img {
  width: 100%;
}
.list_content {
  display: flex;
  padding: 5px;
  margin-top: 10px;
  box-shadow: 0px 0px 3px #ece6e6;
}
.title {
  width: 70%;
  text-align: left;
}
h4 {
  font-size: 1rem;
  margin-top: 1.3rem;
  color: #2c3e50;
  margin-left: 1rem;
}
.sub {
  font-size: 0.8rem;
  margin-top: 1.3rem;
  color: red;
  margin-left: 1rem;
}
.more {
  float: right;
  color: #b8b8b8;
  font-size: 0.8rem;
}
.look {
  float: right;
  color: #45b035;
}
.it {
  font-size: 0.6rem;
  margin: 5px 0;
  margin-left: 1rem;
}
.ej {
  position: absolute;
  width: 100%;
  background-color: #45b035;
  left: 0;
  top: 38px;
  z-index: 100;
  text-align: right;
}
.ej li {
  width: 100%;
  text-align: center;
  color: white;
  border-bottom: 1px solid #fff;
}

.ej li a {
  width: 100%;
  text-align: center;
  color: white;
}
.ej li a:hover {
  color: white;
}
</style>
<style lang="scss" scoped>
@import "../assets/css/rem.scss";
.scroll-wrapper {
  .cube-pulldown-wrapper {
    .before-trigger {
      font-size: 30px;
      line-height: 30px;
      align-self: flex-end;
      span {
        display: inline-block;
        transition: all 0.3s;
        color: #666;
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
    .after-trigger {
      .text {
      }
      .refresh-text {
        color: grey;
      }
    }
  }
}

.scroll-list-wrap {
  background-color: #fff;
  position: absolute;
  top: rem(190);
  left: 0;
  bottom: rem(114);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  transform: rotate(0deg); // fix 子元素超出边框圆角部分不隐藏的问题
  overflow: hidden;
}

.foods-wrapper {
  .food-item {
    display: flex;
    padding: 18px;
    border-bottom: 1px solid rgba(7, 17, 27, 0.1);

    &:last-child {
      // border-none();
      margin-bottom: 0;
    }

    .icon {
      flex: 0 0 57px;
      margin-right: 10px;
    }

    .food-content {
      flex: 1;

      .name {
        margin: 2px 0 8px 0;
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        color: rgb(7, 17, 27);
      }

      .description,
      .extra {
        line-height: 10px;
        font-size: 10px;
        color: rgb(147, 153, 159);
      }

      .description {
        line-height: 12px;
        margin-bottom: 8px;
      }

      .extra {
        .count {
          margin-right: 12px;
        }
      }

      .price {
        font-weight: 700;
        line-height: 24px;

        .now {
          margin-right: 8px;
          font-size: 14px;
          color: rgb(240, 20, 20);
        }

        .old {
          text-decoration: line-through;
          font-size: 10px;
          color: rgb(147, 153, 159);
        }
      }

      .cartcontrol-wrapper {
        position: absolute;
        right: 0;
        bottom: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue